import styled, { css } from 'styled-components';

import { breakpoints } from '@notino/react-styleguide';

interface IDotsWrapperProps {
  isNewPdDesignEnabled: boolean;
}

export const StyledDotsWrapper = styled.ol<IDotsWrapperProps>`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  width: 100%;
  height: 1.25em;
  margin: 0;
  list-style: none;
  margin-top: 1em;

  ${({ isNewPdDesignEnabled }) =>
    isNewPdDesignEnabled &&
    css`
      @media (min-width: ${breakpoints.xxl}) {
        width: 85%;
      }
    `};

  li {
    position: relative;
    display: block;
    user-select: none;
    outline: 0;
    padding: 0;
    flex: 0 1 auto;
    height: 1.25em;
    max-width: 3.125em;
    width: 3.125em;
    margin: 0 0.25em;
    cursor: pointer;

    &::before {
      display: none !important;
    }

    @media (min-width: ${breakpoints.md}) {
      max-width: 6.25em;
      width: 6.25em;
      margin: 0 0.5em;
    }
  }
`;
